/**
 * Logger Utility
 * A simple utility for toggling logging on and off across the theme
 */

(function(window) {
  'use strict';
  
  // Create the logger object
  const Logger = {
    // Check if debug is enabled in localStorage
    isEnabled: function() {
      return localStorage.getItem('db_debug_enabled') === 'true';
    },
    
    // Enable logging
    enable: function() {
      localStorage.setItem('db_debug_enabled', 'true');
      this.log('Debugging enabled');
      return 'Debugging enabled. You will now see all debug logs.';
    },
    
    // Disable logging
    disable: function() {
      this.log('Debugging disabled');
      localStorage.setItem('db_debug_enabled', 'false');
      return 'Debugging disabled. Debug logs are now hidden.';
    },
    
    // Toggle logging state
    toggle: function() {
      return this.isEnabled() ? this.disable() : this.enable();
    },
    
    // Status check
    status: function() {
      return `Debugging is currently ${this.isEnabled() ? 'ENABLED' : 'DISABLED'}`;
    },
    
    // Log method (only logs when enabled)
    log: function(...args) {
      if (this.isEnabled()) {
        console.log(...args);
      }
    },
    
    // Error method (always logs)
    error: function(...args) {
      console.error(...args);
    },
    
    // Warning method (always logs)
    warn: function(...args) {
      console.warn(...args);
    },
    
    // Info method (only logs when enabled)
    info: function(...args) {
      if (this.isEnabled()) {
        console.info(...args);
      }
    },
    
    // Group method (only logs when enabled)
    group: function(label) {
      if (this.isEnabled()) {
        console.group(label);
      }
    },
    
    // Group end method
    groupEnd: function() {
      if (this.isEnabled()) {
        console.groupEnd();
      }
    }
  };
  
  // Expose the logger to the global scope
  window.DBLogger = Logger;
  
  // Add some helper commands for the console
  window.dbDebug = {
    on: Logger.enable.bind(Logger),
    off: Logger.disable.bind(Logger),
    toggle: Logger.toggle.bind(Logger),
    status: Logger.status.bind(Logger)
  };
  
  // Initialize with debug disabled by default, unless it's explicitly enabled
  if (localStorage.getItem('db_debug_enabled') === null) {
    localStorage.setItem('db_debug_enabled', 'false');
  }
  
})(window);